import React, { Component } from "react";
import { BusinessPortalHeader, PortalLoadingState, PortalPageShell, LottieLoadingIndicator } from "src/components";
import { getSalesAndPromotionHeading } from "./SalesAndPromotionHeader";

class LoadingPage extends Component {
    render() {
        const { user } = this.props; 
        const heading = getSalesAndPromotionHeading(user);
        return (
            <PortalPageShell maxWidth="94.5rem">
                <BusinessPortalHeader
                    title={heading}
                />
                    
                <PortalLoadingState
                    minHeight="40rem"
                    style={{
                        overflowX: "auto",
                        maxWidth: "94.5rem",
                    }}
                >
                    <LottieLoadingIndicator />
                </PortalLoadingState>
            </PortalPageShell>
        );
    }
}

export default LoadingPage;
